module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAABaElEQVRIS63WsUoEQQyA4T+IWIvPoK0Wgp2FhfoAFvoeVqK+jwjW4mkhKFjY2/oG4tkIIpHI7LG3OzuTuZ1rl8tHMklmRFXPgEvgGTgSkQ8q/VR1DbgBdoBzUdVvYCXEfwX2a4ABuge2Quwvwx6AvVYyo8EIZOFvDVsF7oDtGuAA9AIcigG1wCQk8vmP1QBzkBkzbAzogXrYIqAXimIlYAI6EJFpd1znytj+mGuaUmgwM0fTnADXrYG1v1h7RzNq4g1mlgF/gaVWJbJQNrMM2Hx2QW4sNM068NbJ6AfYEJF3z+7OljFAtr1th25Ggrp3aRYLXdeFLKPl0l2axAYgO6OmG4uWd2rOYqWbNUNuDmNnGMUSGc3NUSnYw7yQY/B7N3536ydLN9Te3gzb99lCUEmGzU09CvKC9gapArlAVX0EdkuXamo9DZzhpPtudC/V3C6MgFPDTsOL+Ak4jt2wucCZLr0KL+KLP2rtFmkwNnACAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/vote-dialog-close.png
// module id = TjQ3
// module chunks = 1